import { render, staticRenderFns } from "./ebarimtEasyRegister.vue?vue&type=template&id=8c787528&"
import script from "./ebarimtEasyRegister.vue?vue&type=script&lang=js&"
export * from "./ebarimtEasyRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports